module.exports = __webpack_public_path__ + "img/zhifubao.bf9ec65b.png";